import { colors } from '@crehana/tailwindcss';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { css } from 'styled-components';

colors;

export const StepNumber = styled.div<{ isActive: boolean; isDark: boolean }>(
  ({ theme, isActive, isDark }) => css`
    background-color: ${
      isActive
        ? colors['primary-light'][100]
        : isDark
          ? theme.colors.gray['lighter-dark-mode']
          : theme.colors.gray.main
    };
    color: ${
      isDark && !isActive ? theme.colors.base.lighter : theme.colors.white
    };
  `,
);

export const HighlightParagraph = styled.div<{
  isActive: boolean;
  isDark: boolean;
}>(
  ({ theme, isActive, isDark }) => css`
    color: ${
      isDark
        ? isActive
          ? theme.colors.white
          : theme.colors.gray['lighter-dark-mode']
        : isActive
          ? theme.colors.base.main
          : theme.colors.gray.main
    };
  `,
);

export const Divisor = styled.hr<{ isDark: boolean }>(
  ({ theme, isDark }) => css`
    width: 100%;
    max-width: 40px;
    border-bottom: 1px solid
      ${
        isDark ? theme.colors.gray['lighter-dark-mode'] : theme.colors.gray.main
      };
  `,
);
